(() => {
  if (customElements.get('x-modal')) return;

  class XModal extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      
      this.shadowRoot.innerHTML = `
        <style>
          :host { display: contents; }

          /* OVERLAY — fade z dostępnością i bez "skoków" */
          .backdrop{
            position: fixed; inset: 0;
            display: flex;                          
            align-items: center; justify-content: center;
            background: rgba(0,0,0,.5);
            z-index: 2147483647;

            opacity: 0;                             
            visibility: hidden;
            pointer-events: none;                   
            transition:
              opacity .18s ease-out,
              visibility 0s linear .18s;            
          }
          :host([open]) .backdrop{
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            transition:
              opacity .18s ease-out,
              visibility 0s;                      
          }

          /* PANEL — subtelny slide+scale */
          .panel{
            background-color: rgba(var(--background-color), 1);
            width: min(90vw, 640px);
            max-height: 80vh; overflow: auto;
            border-radius: 12px; box-shadow: 0 10px 30px rgba(0,0,0,.25);
            padding: 16px 20px;

            transform: translateY(8px) scale(.98);
            opacity: 0;
            transition:
              transform .18s cubic-bezier(.2,.7,.3,1),
              opacity .18s ease-out;
            will-change: transform, opacity;
          }
          :host([open]) .panel{
            transform: none;
            opacity: 1;
          }

          // :host-context(.dark) .panel {
          //   background: #1c1c1e;
          // }

          :host-context(.dark) .close {
            color: #e1e3e1;
          }

          .close{
            color: rgb(var(--colors-text));
            position: absolute; top:10px; right:10px;
            border:0; background:transparent; font-size:20px; line-height:1;
            width:36px; height:36px; border-radius:8px; cursor:pointer;
          }
          .close:hover{ background: rgba(0,0,0,.06); }

          .panel-wrap{ position: relative; }
          
          @media (prefers-reduced-motion: reduce){
            .backdrop, .panel { transition: none !important; }
          }
        </style>

        <div class="backdrop" data-modal-close>
          <div class="panel-wrap">
            <div class="panel" role="dialog" aria-modal="true" aria-labelledby="modal-title">
              <button class="close" type="button" aria-label="Close" data-modal-close>
                <svg class="" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: none;">
                  <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L12 10.5858L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L13.4142 12L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L12 13.4142L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071C2.90237 20.3166 2.90237 19.6834 3.29289 19.2929L10.5858 12L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"/>
                </svg>  
              </button>
              <slot></slot>
            </div>
          </div>
        </div>
    `;

      this._onDocClick = this._onDocClick.bind(this);
      this._onKey = this._onKey.bind(this);
      this._onShadowClick = this._onShadowClick.bind(this);
    }

    connectedCallback(){
      if (this.id) {
        const dup = [...document.querySelectorAll(`x-modal#${CSS.escape(this.id)}`)].find(el => el !== this);
        if (dup) dup.remove();
      }

      if (this.parentNode !== document.body) document.body.appendChild(this);

      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onKey);

      this.shadowRoot.addEventListener('click', this._onShadowClick);
    }

    disconnectedCallback(){
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onKey);
      this.shadowRoot.removeEventListener('click', this._onShadowClick);
    }

    _onDocClick(e){
      const openBtn = e.target.closest?.('[data-modal-open]');
      if (openBtn && openBtn.getAttribute('data-modal-open') === this.id) {
        e.preventDefault();
        this.open();
      }
    }

    _onShadowClick(e){
      if (e.target.closest('[data-modal-close]')) {
        e.preventDefault();
        this.close();
        return;
      }

      const bd = this.shadowRoot.querySelector('.backdrop');
      if (e.target === bd) this.close();
    }

    _onKey(e){
      if (!this.hasAttribute('open')) return;
      if (e.key === 'Escape') { e.preventDefault(); this.close(); }
    }

    open(){
      this.setAttribute('open','');

      const docEl = document.documentElement;
      const body = document.body;

      const n = +(body.dataset.gmLockCount || 0) + 1;
      body.dataset.gmLockCount = String(n);

      if (n === 1) {
        const sbw = window.innerWidth - docEl.clientWidth;
        body.dataset.gmPrevOverflow = body.style.overflow || '';
        body.dataset.gmPrevPaddingRight = getComputedStyle(body).paddingRight;

        docEl.style.setProperty('--width-scrollbar', sbw + 'px');

        if (sbw > 0) {
          const pr = parseFloat(getComputedStyle(body).paddingRight) || 0;
          body.style.paddingRight = (pr + sbw) + 'px';
        }
        body.style.overflow = 'hidden';
      }
    }

    close(){
      if (!this.hasAttribute('open')) return;

      this.removeAttribute('open');

      const body = document.body;
      const docEl = document.documentElement;
      const n = Math.max( (+(body.dataset.gmLockCount || 1)) - 1, 0 );
      body.dataset.gmLockCount = String(n);

      if (n === 0) {
        body.style.overflow = body.dataset.gmPrevOverflow || '';
        body.style.paddingRight = body.dataset.gmPrevPaddingRight || '';
        delete body.dataset.gmPrevOverflow;
        delete body.dataset.gmPrevPaddingRight;

        docEl.style.removeProperty('--width-scrollbar');
      }
    }
  }

  customElements.define('x-modal', XModal);
})();